function normalize(value) {
  return String(value ?? '').trim()
}

function expectedRoles(shares) {
  return Number(shares) >= 3
    ? new Set(['TARGET_ENTRY', 'RUNNER_ENTRY'])
    : new Set(['ENTRY'])
}

export function hasLiveSetupOrderEvidence(results) {
  return (Array.isArray(results) ? results : []).some(row => (
    row?.success === true
    && row?.orderId != null
    && (row?.rollbackAttempted !== true || row?.manualCleanupRequired === true)
  ))
}

/**
 * Compare saved setup sizing with exact tracked IDs that Schwab still reports
 * as non-terminal. Complete accounts are retained; incomplete accounts are
 * rebuilt as a whole so a target/runner pair can never be doubled.
 */
export function buildSetupRepairPlan({ accountSizing, trackedOrders, cancelPayloads }) {
  const liveIds = new Set((cancelPayloads || []).map(row => normalize(row?.existingOrderId)).filter(Boolean))
  const activeTracked = (trackedOrders || []).filter(row => liveIds.has(normalize(row?.orderId)))
  const affectedAccountNumbers = []
  const retainedTrackedOrders = []
  const affected = new Set()

  for (const sizing of accountSizing || []) {
    const accountNumber = normalize(sizing?.account_number)
    if (!accountNumber || Number(sizing?.shares) <= 0) continue
    const rows = activeTracked.filter(row => normalize(row?.accountNumber ?? row?.account_number) === accountNumber)
    const roles = new Set(rows.map(row => normalize(row?.role).toUpperCase()))
    const complete = [...expectedRoles(sizing.shares)].every(role => roles.has(role))
      && !roles.has('ORPHAN_NEEDS_CLEANUP')
    if (complete) retainedTrackedOrders.push(...rows)
    else {
      affected.add(accountNumber)
      affectedAccountNumbers.push(accountNumber)
    }
  }

  return {
    complete: affectedAccountNumbers.length === 0,
    affectedAccountNumbers,
    retainedTrackedOrders,
    cancelPayloads: (cancelPayloads || []).filter(row => affected.has(normalize(row?.account_number))),
  }
}
